<template>
  <div id="app">
    <Menu />
	<div class="content">
		<router-view></router-view>
	</div>
  </div>
</template>

<script>
import Menu from './components/Menu.vue'

export default {
	name: 'App',
	properties:{
	},
	components: {
	Menu
	},
	beforeCreate: function() {
		if (this.$cookies.get('token') == null) {
			this.$router.push("/"); 
		}
		this.$http.defaults.headers.common = {
			"Authorization": "bearer " + this.$cookies.get('token')
		};
	}
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#content{
	margin: 40px;
	margin-top: 40px;
	max-width:1400px; 
	margin-right:auto; 
	margin-left:auto;
	padding-left: 40px;
	padding-right: 40px;
}
.submenu {
	background-color: gainsboro;
	height: 30px;
	font-size: 14px;
	margin-top: 1px;
}
.submenu a, .submenu a:hover{
	color: #222222;
	text-decoration: none;
	margin-right: 20px;
}
.navbar-nav a {
	margin-right: 20px;
}
.sidebar .text-dark{
	color: white !important;
}
</style>
